/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PhysicianScheduleBlockIndividualEditAliases {
  OBSERVATION_FIELD = 'observation-field',
  PHYSICIAN_SCHEDULE_BLOCK_DATE_TIME_FIELD = 'physician-schedule-block-date-time-field',
  PHYSICIAN_SCHEDULE_BLOCK_DATE_TIME_TEXT = 'physician-schedule-block-date-time-text',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT_CONTEXTUAL_BAR = 'physician-schedule-block-individual-edit-contextual-bar',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT_DATE_TIME_PANEL = 'physician-schedule-block-individual-edit-date-time-panel',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT_FORM = 'physician-schedule-block-individual-edit-form',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT_LAYOUT = 'physician-schedule-block-individual-edit-layout',
  PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT_PANEL = 'physician-schedule-block-individual-edit-panel',
  PHYSICIAN_SCHEDULE_BLOCK_OBSERVATION_TEXT_AREA = 'physician-schedule-block-observation-text-area',
  REASON_AUTOCOMPLETE = 'reason-autocomplete',
  REASON_FETCH = 'reason-fetch',
  REASON_FIELD = 'reason-field',
  REASON_MAPPER = 'reason-mapper',
  REASON_TEXT = 'reason-text',
}
export { PhysicianScheduleBlockIndividualEditAliases };
